module.exports = __webpack_public_path__ + "static/flasche-terra-medium-205c3ddf59ca99a926510a1d8904d027.png";